<template>
  <div
    :class="[$style.awShowMore, {[$style.awShowMoreShortContent]: shortContent}, {[$style.awShowMoreOpened]: opened}]"
  >
    <div
      :class="$style.awShowMoreContent"
      :style="{height: opened ? ((minHeaderHeight + contentHeight) + 'px') : (shortContent ? '100%' : (maxContentHeight + 'px'))}"
    >
      <div :class="$style.awShowMoreContentInner">
        <slot />
      </div>
    </div>

    <div v-if="!shortContent" :class="$style.awShowMoreHeader">
      <div :class="$style.awShowMoreHeaderItem" @click="toggleOpened">
        <lv-button type="button" styling="link-primary">
          <span class="icon__text" :class="$style.text">
            {{ opened ? closeText : openText }}
          </span>
          <lv-icon name="arrow-right-16" :class="$style.icon" :size="16" />
        </lv-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { LvButton, LvIcon } from '~~/common/components/loginet-vue-shop/index.mjs';

  export default {
    name: 'AwShowMoreVersion2',
    components: {
      LvButton,
      LvIcon,
    },
    props: {
      content: {
        type: String,
        default: '',
      },
      maxContentHeight: {
        type: Number,
        default: 170,
      },
      openText: {
        type: String,
        required: true,
      },
      closeText: {
        type: String,
        required: true,
      },
      defaultOpened: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['show-more-changed'],
    data () {
      return {
        shortContent: false,
        opened: this.defaultOpened,
        contentHeight: null,
        minHeaderHeight: 0,
      };
    },
    watch: {
      defaultOpened (newVal) {
        this.opened = newVal;
      },
    },
    mounted () {
      const el = this.$el.children[0].children[0].children[0];
      if (!el) {
        this.$logger.error('Cannot render an empty slot.');
        return;
      }
      const s = window.getComputedStyle(el, null);
      this.contentHeight = el.clientHeight + parseInt(s.getPropertyValue('margin-top')) + parseInt(s.getPropertyValue('margin-bottom'));
      this.shortContent = this.contentHeight < this.maxContentHeight;
    },
    methods: {
      toggleOpened () {
        this.opened = !this.opened;
        setTimeout(() => this.$emit('show-more-changed', this.opened), 1000);
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
//theme variables
$show-more-header-background: transparent !default;

.awShowMore {
  $self: &;
  position: relative;
  margin-bottom: 40px;

  &Content {
    overflow: hidden;
    transition: all 0.8s ease-out;
  }

  &Header {
    position: absolute;
    bottom: -40px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    width: 100%;
    transition: height ease-in $animation-speed-medium, background ease-in $animation-speed-medium;
    background: $show-more-header-background;

    &Item {
      cursor: pointer;

      .text {
        font-family: $secondary-font;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        color: $color-text-primary;
      }

      .icon {
        color: $color-text-primary;
      }

      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }

  .icon {
    transition: transform ease-in $animation-speed-medium;
    transform: rotate(90deg);
  }

  &Opened {
    #{$self} {
      &Content {
        height: 100%;
        max-height: 100%;
        transition: all 0.8s ease-in-out;
      }

      &Header {
        height: 35px;

        .icon {
          transform: rotate(-90deg);
        }
      }
    }
  }

  &ShortContent {
    margin-bottom: 0;

    #{$self} {
      &Header {
        display: none;
      }
    }
  }
}
</style>
